import PropTypes from 'prop-types';
import React from 'react';
import I18n from 'i18n-js';
import { tv } from 'tailwind-variants';
import { TCITooltip } from '@/components/ui/Tooltip';
import cn from '@/utils/cn';
import useFlags from '@/hooks/useFlags';
import styles from './NavigationCard.module.scss';
import libraries from './libraries';

const libraryLinkStyles = tv({
  base: styles.libraryLink,
  variants: {
    reflow: {
      true: 'first:!tw-ml-0 tw-w-full',
    },
  },
});

const libraryLinksStyles = tv({
  base: styles.libraryLinks,
  variants: {
    reflow: {
      true: '!tw-grid tw-grid-cols-[repeat(auto-fill,7rem)] tw-justify-start tw-items-start !tw-gap-x-1 !tw-gap-y-6',
    },
  },
});

const LibraryLink = ({ className, comingSoon, icon, text, tooltip, url, programId, lessonId }) => {
  const { accessibilityReflow } = useFlags();

  const link = (
    <a
      className={cn(libraryLinkStyles({ reflow: accessibilityReflow }), comingSoon && styles.comingSoon)}
      href={url(programId, lessonId)}
    >
      <div className={`${styles.icon} ${className} ${comingSoon && styles.comingSoon}`}>
        <img alt="" src={icon} />
      </div>
      <p className="tw-bg-white">{I18n.t(text)}</p>
    </a>
  );

  if (!tooltip) return link;

  return (
    <TCITooltip>
      <TCITooltip.Trigger asChild>
        {link}
      </TCITooltip.Trigger>
      <TCITooltip.Content>
        {tooltip}
      </TCITooltip.Content>
    </TCITooltip>
  );
};

LibraryLink.defaultProps = {
  comingSoon: false,
  tooltip: null,
};

LibraryLink.propTypes = {
  className: PropTypes.string.isRequired,
  comingSoon: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  lessonId: PropTypes.number,
  programId: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  url: PropTypes.func.isRequired,
};

const LibraryLinks = ({ programId, lessonId, unitId, civicsLibraryEnabled, primarySourceLibraryEnabled }) => {
  const { accessibilityReflow } = useFlags();

  return (
    <div className={libraryLinksStyles({ reflow: accessibilityReflow })}>
      {libraries(
        unitId,
        civicsLibraryEnabled,
        primarySourceLibraryEnabled
      ).map(
        library => (<LibraryLink key={library.text} {...library} lessonId={lessonId} programId={programId} />)
      )}
    </div>
  );
};

LibraryLinks.propTypes = {
  civicsLibraryEnabled: PropTypes.bool.isRequired,
  lessonId: PropTypes.number,
  primarySourceLibraryEnabled: PropTypes.bool.isRequired,
  programId: PropTypes.number.isRequired,
  unitId: PropTypes.number,
};

LibraryLinks.defaultProps = {
  unitId: null,
};

export default LibraryLinks;
